<template>
    <div class="form-group" :class="model.size">
        <label class="font-weight-bold" :for="'datepicker' + _uid">
            {{ isEnVersion ? model.labelEn : model.label }}
        </label>
        <div aria-describedby="descriptionHelp">
            <datetime-picker v-model="selectedDate"
                             :min="model.datetimeMinValue"
                             :max="model.datetimeMaxValue"
                             :format="format"
                             :time-format="timeFormat"
                             :name="'datetimepicker' + _uid"
                             :data-vv-as="model.label"
                             :showTime="showTime"
                             :class="model.fieldCode"
                             :readonly="model.isReadOnly || details"
                             v-validate="validations">
            </datetime-picker>
        </div>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>
        <span class="text-danger" v-if="errors.has('datetimepicker' + _uid)">{{ errors.first('datetimepicker' + _uid) }}</span>
    </div>
</template>

<script>
    import DatetimePicker from '../../components/datepicker/DatePicker';
    import { mapGetters } from 'vuex';
    import { RegisterEventBus } from '@/buses/register-bus.js';

    export default {
        inject: ['$validator'],
        props: {
            value: String,
            model: Object,
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            showTime: {
                type: Boolean,
                default: true
            },
            profileData: {
                type: Object,
                default() {
                    return null;
                }
            },
            isEvaluationPanel: {
                type: Boolean,
                default: false
            }
        },
        components: {
            DatetimePicker
        },
        data() {
            return {
                selectedDate: '',
                validations: '',
                format: 'dd.MM.yyyy HH:mm',
                timeFormat: 'HH:mm'
            }
        },
        methods: {
            addValidations() {
                if (this.model.isRequired) {
                    this.addValidation('required');
                }

                if (this.model.datetimeMinValue && this.model.datetimeMaxValue) {
                    const rules = `data_format=${this.format}|date_between:${this.model.datetimeMinValue},${this.model.datetimeMaxValue}`;
                    this.addValidation(rules);
                }
            },
            addValidation(validation) {
                if (this.validations.length > 0) {
                    this.validations += '|';
                }
                this.validations += validation;
            },
            loadInitialValue() {
                this.selectedDate = this.model.fieldValue.datetimeValue
                    ? this.model.fieldValue.datetimeValue : this.model.datetimeDefaultValue;
                this.model.fieldValue.datetimeValue = this.selectedDate;
                this.model.fieldValue.stringValue = this.selectedDate;
                this.setEventDate(this.selectedDate);
            },
            setEventDate(date) {
                if (this.model.fieldCode === 'Event_start') {
                    this.$parent.$parent.$parent.eventDateFrom = date;
                } else if (this.model.fieldCode === 'Event_end') {
                    this.$parent.$parent.$parent.eventDateTo = date;
                }
            },
            componentReset() {
                this.loadInitialValue();
            },
            fillProfileData(data) {
                if (!data) {
                    return;
                }

                this.$helpers.fillProfileDataToDynamicForm(this.model, data);
            }
        },
        watch: {
            selectedDate: function (newVal, oldVal) {
                this.model.fieldValue.datetimeValue = this.selectedDate;
                this.setEventDate(newVal);
                this.$emit('input', this.selectedDate);
                RegisterEventBus.$emit('dynamic-field-change', newVal, oldVal, this.model, this);
                this.model.fieldValue.stringValue = this.selectedDate;
            },
            profileData: {
                handler: function (newVal, oldVal) {
                    this.fillProfileData(newVal);
                },
                deep: true,
                immediate: true,
            },
        },
        mounted() {
            this.addValidations();
            this.loadInitialValue();
            this.model.uid = this._uid;
            this.model.isEvaluationPanel = this.isEvaluationPanel;
        },
        created() {
            RegisterEventBus.$on(`component-${this.model.fieldCode}-${this.model.id}-reset`, this.componentReset);
        },
        destroyed() {
            RegisterEventBus.$off(`component-${this.model.fieldCode}-${this.model.id}-reset`, this.componentReset);
        },
        computed: {
            ...mapGetters(['isEnVersion']),
        }
    }
</script>
